import { useMemo } from 'react';
import { Division } from '@chargify/data-access';
import { CustomerDetailsModel } from '../models';

interface AddressItems {
  items: Division[];
  isLoading: boolean;
}

export const useDataWithNames = ({
  countries,
  subdivisions,
  data,
}: {
  countries: AddressItems;
  subdivisions: AddressItems;
  data: CustomerDetailsModel;
}) => {
  const dataWithNames = useMemo(() => {
    const countryName =
      countries && data?.country
        ? countries.items.find(({ code }) => code === data.country)?.name
        : null;
    const subdivisionName =
      subdivisions && data?.state
        ? subdivisions.items.find(({ code }) => code === data.state)?.name
        : null;
    return {
      ...data,
      ...(countryName && { country: countryName }),
      ...(subdivisionName && { state: subdivisionName }),
    };
  }, [data, countries, subdivisions]);

  return dataWithNames;
};
